import React from "react";
import flexiblerepayment from "../assets/whychooseus/flexiblerepayment.png";
import leftwhychooseimage from "../assets/whychooseus/leftwhychooseimage.png";
import leftwhychooseimagerighttopicon from "../assets/whychooseus/leftwhychooseimagerighttopicon.png";
import trustedpartner from "../assets/whychooseus/trustedpartner.png";

const WhyChooseUs: React.FC = () => {
  return (
    <section className="w-full py-4 md:py-28 px-6 lg:px-20 flex flex-col items-center overflow-hidden bg-white">
      {/* Mobile Heading: Visible only on mobile */}
      <div className="flex lg:hidden flex-col items-center w-full mb-8">
        <h2 className="text-3xl sm:text-4xl font-kualine font-semibold leading-[1.15] tracking-tight text-neutral-900 text-center">
          Lending support when
          <span className="block text-[#DE3226] mt-2">you need it most.</span>
        </h2>
      </div>

      <div className="max-w-[1400px] w-full grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        {/* Left Column: Portrait Couple Card */}
        <div className="col-span-1 lg:col-span-5 w-full flex justify-center">
          <div className="relative w-full max-w-[480px] lg:max-w-none aspect-[16/11] lg:aspect-auto lg:h-[680px] rounded-[24px] md:rounded-[32px] overflow-hidden shadow-sm">
            <img
              src={leftwhychooseimage}
              alt="Lending support couple"
              className="w-full h-full object-cover"
            />
            {/* Red logo overlay icon at top left */}
            <img
              src={leftwhychooseimagerighttopicon}
              alt="Dezire Loan Brand Icon"
              className="absolute top-6 left-6 w-16 h-16 object-contain z-10 hidden lg:block"
            />
          </div>
        </div>

        {/* Right Column: Heading, CTA and Dual Feature Cards */}
        <div className="col-span-1 lg:col-span-7 flex flex-col items-center lg:items-start w-full">
          {/* Header Badge */}
          <div className="hidden lg:flex items-center gap-3 text-neutral-500 uppercase tracking-[0.15em] text-xs md:text-sm font-bold mb-3">
            <span className="w-7 h-[1.5px] bg-neutral-400" />
            <span>Why Dezire Loan</span>
          </div>

          {/* Heading */}
          <h2 className="hidden lg:block text-3xl sm:text-4xl md:text-5xl lg:text-[50px] font-black leading-[1.15] tracking-tight text-neutral-900 mt-2 text-left">
            Lending support when
            <span className="block text-[#DE3226] mt-2">you need it most.</span>
          </h2>

          {/* CTA Button */}
          <a
            href={import.meta.env.VITE_WEBSITE_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden lg:inline-flex bg-[#DE3226] hover:bg-[#A82A1B] text-white px-8 py-3.5 rounded-[12px] font-bold text-base mt-6 shadow-sm active:scale-95 transition-all w-fit"
          >
            Apply Now
          </a>

          {/* Dual Cards Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6 lg:mt-10 w-full items-stretch">
            {/* Card 1: Flexible Repayment */}
            <div className="flex flex-col h-full bg-[#FDFBF9] lg:bg-white border border-[#E2E8F0] rounded-[24px] lg:rounded-[20px] p-5 lg:p-8 hover:shadow-md transition-shadow">
              {/* Image Frame (Top on mobile, bottom on desktop) */}
              <div className="relative order-first lg:order-none md:mb-4 lg:mb-0 lg:mt-auto aspect-[16/10] w-full overflow-hidden rounded-[16px] lg:rounded-[12px]">
                <img
                  src={flexiblerepayment}
                  alt="Flexible Repayment"
                  className="w-full h-full object-cover"
                />
                <div
                  className="absolute inset-0 pointer-events-none"
                  style={{ backgroundColor: "#E5393526" }}
                />
              </div>

              {/* Header text & Icon */}
              <div className="flex items-start justify-between mb-2 lg:mb-0 lg:mt-3">
                <h3 className="text-lg md:text-xl font-semibold text-neutral-800 leading-tight mt-4 md:mt-0">
                  Flexible Repayment
                </h3>
                {/* Custom SVG calendar icon */}
                <div className="hidden lg:block text-[#DE3226] bg-[#DE3226]/10 p-2 rounded-[12px] shrink-0">
                  <svg
                    width="30"
                    height="33"
                    viewBox="0 0 30 33"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M27.5 2.5H23.75V1.25C23.75 0.918479 23.6183 0.600537 23.3839 0.366116C23.1495 0.131696 22.8315 0 22.5 0C22.1685 0 21.8505 0.131696 21.6161 0.366116C21.3817 0.600537 21.25 0.918479 21.25 1.25V2.5H8.75V1.25C8.75 0.918479 8.6183 0.600537 8.38388 0.366116C8.14946 0.131696 7.83152 0 7.5 0C7.16848 0 6.85054 0.131696 6.61612 0.366116C6.3817 0.600537 6.25 0.918479 6.25 1.25V2.5H2.5C1.83696 2.5 1.20107 2.76339 0.732233 3.23223C0.263392 3.70107 0 4.33696 0 5V30C0 30.663 0.263392 31.2989 0.732233 31.7678C1.20107 32.2366 1.83696 32.5 2.5 32.5H27.5C28.163 32.5 28.7989 32.2366 29.2678 31.7678C29.7366 31.2989 30 30.663 30 30V5C30 4.33696 29.7366 3.70107 29.2678 3.23223C28.7989 2.76339 28.163 2.5 27.5 2.5ZM12.5 26.25C12.5 26.5815 12.3683 26.8995 12.1339 27.1339C11.8995 27.3683 11.5815 27.5 11.25 27.5C10.9185 27.5 10.6005 27.3683 10.3661 27.1339C10.1317 26.8995 10 26.5815 10 26.25V18.2719L9.30938 18.6188C9.01266 18.7671 8.66917 18.7915 8.35446 18.6866C8.03975 18.5817 7.7796 18.3561 7.63125 18.0594C7.48289 17.7627 7.45848 17.4192 7.56339 17.1045C7.66829 16.7898 7.89391 16.5296 8.19062 16.3812L10.6906 15.1312C10.8813 15.0359 11.0931 14.9908 11.3061 15.0004C11.5191 15.0099 11.7261 15.0738 11.9074 15.1859C12.0887 15.298 12.2383 15.4547 12.3421 15.6409C12.4458 15.8271 12.5002 16.0368 12.5 16.25V26.25ZM21.25 25C21.5815 25 21.8995 25.1317 22.1339 25.3661C22.3683 25.6005 22.5 25.9185 22.5 26.25C22.5 26.5815 22.3683 26.8995 22.1339 27.1339C21.8995 27.3683 21.5815 27.5 21.25 27.5H16.25C16.0179 27.5 15.7903 27.4354 15.5928 27.3133C15.3954 27.1913 15.2358 27.0166 15.132 26.809C15.0282 26.6014 14.9842 26.3689 15.005 26.1377C15.0259 25.9065 15.1107 25.6857 15.25 25.5L19.7469 19.5047C19.8492 19.3685 19.9225 19.2129 19.9625 19.0473C20.0025 18.8818 20.0082 18.7098 19.9793 18.542C19.9504 18.3741 19.8876 18.214 19.7946 18.0713C19.7016 17.9286 19.5804 17.8065 19.4385 17.7123C19.2965 17.6182 19.1369 17.554 18.9693 17.5238C18.8017 17.4936 18.6297 17.4979 18.4638 17.5366C18.2979 17.5752 18.1417 17.6473 18.0047 17.7485C17.8677 17.8497 17.7529 17.9778 17.6672 18.125C17.5875 18.2717 17.4793 18.4009 17.3489 18.5051C17.2185 18.6093 17.0685 18.6863 16.9078 18.7316C16.7472 18.7769 16.5791 18.7896 16.4135 18.7688C16.2478 18.7481 16.088 18.6944 15.9435 18.6109C15.7989 18.5274 15.6726 18.4158 15.5719 18.2827C15.4711 18.1496 15.3981 17.9977 15.3571 17.8359C15.316 17.6741 15.3078 17.5057 15.3329 17.3407C15.358 17.1756 15.4159 17.0173 15.5031 16.875C15.916 16.1605 16.5531 15.6021 17.3156 15.2864C18.0782 14.9707 18.9235 14.9154 19.7207 15.1291C20.5178 15.3427 21.2222 15.8133 21.7247 16.4679C22.2272 17.1226 22.4997 17.9247 22.5 18.75C22.5027 19.5652 22.2369 20.3587 21.7438 21.0078L18.75 25H21.25ZM2.5 10V5H6.25V6.25C6.25 6.58152 6.3817 6.89946 6.61612 7.13388C6.85054 7.3683 7.16848 7.5 7.5 7.5C7.83152 7.5 8.14946 7.3683 8.38388 7.13388C8.6183 6.89946 8.75 6.58152 8.75 6.25V5H21.25V6.25C21.25 6.58152 21.3817 6.89946 21.6161 7.13388C21.8505 7.3683 22.1685 7.5 22.5 7.5C22.8315 7.5 23.1495 7.3683 23.3839 7.13388C23.6183 6.89946 23.75 6.58152 23.75 6.25V5H27.5V10H2.5Z"
                      fill="#E53935"
                      fillOpacity="0.5"
                    />
                  </svg>
                </div>
              </div>

              <p className="text-neutral-900 text-sm md:text-[14px]  font-light leading-relaxed mt-2 lg:mt-3 mb-2 lg:mb-6">
                Choose repayment plans designed to fit comfortably within your
                monthly income.
              </p>
            </div>

            {/* Card 2: Trusted Lending Partners */}
            <div className="flex flex-col h-full bg-[#FDFBF9] lg:bg-white border border-[#E2E8F0] rounded-[24px] lg:rounded-[20px] p-5 lg:p-8 hover:shadow-md transition-shadow">
              {/* Image Frame (Top on mobile, bottom on desktop) */}
              <div className="relative order-first lg:order-none mb-4 lg:mb-0 lg:mt-auto aspect-[16/10] w-full overflow-hidden rounded-[16px] lg:rounded-[12px]">
                <img
                  src={trustedpartner}
                  alt="Trusted Lending Partners"
                  className="w-full h-full object-cover"
                />
                <div
                  className="absolute inset-0 pointer-events-none"
                  style={{ backgroundColor: "#E5393526" }}
                />
              </div>

              {/* Header text & Icon */}
              <div className="flex items-start justify-between mb-2 lg:mb-0 lg:mt-3">
                <h3 className="text-lg md:text-xl font-semibold text-neutral-800 leading-tight">
                  Trusted Lending Partners
                </h3>
                {/* Custom SVG check shield icon */}
                <div className="hidden lg:block text-[#DE3226] bg-[#DE3226]/10 p-2 rounded-[12px] shrink-0">
                  <svg
                    width="30"
                    height="32"
                    viewBox="0 0 30 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M27.5 0H2.5C1.83696 0 1.20107 0.263392 0.732233 0.732233C0.263392 1.20107 0 1.83696 0 2.5V11.25C0 19.4875 3.9875 24.4797 7.33281 27.2172C10.9359 30.1641 14.5203 31.1641 14.6766 31.2063C14.8914 31.2647 15.118 31.2647 15.3328 31.2063C15.4891 31.1641 19.0688 30.1641 22.6766 27.2172C26.0125 24.4797 30 19.4875 30 11.25V2.5C30 1.83696 29.7366 1.20107 29.2678 0.732233C28.7989 0.263392 28.163 0 27.5 0ZM22.1375 10.8844L13.3875 19.6344C13.2714 19.7506 13.1335 19.8428 12.9818 19.9057C12.8301 19.9686 12.6674 20.001 12.5031 20.001C12.3389 20.001 12.1762 19.9686 12.0244 19.9057C11.8727 19.8428 11.7348 19.7506 11.6188 19.6344L7.86875 15.8844C7.6342 15.6498 7.50243 15.3317 7.50243 15C7.50243 14.6683 7.6342 14.3502 7.86875 14.1156C8.1033 13.8811 8.42142 13.7493 8.75312 13.7493C9.08483 13.7493 9.40295 13.8811 9.6375 14.1156L12.5 16.9828L20.3656 9.11562C20.4818 8.99949 20.6196 8.90736 20.7714 8.84451C20.9231 8.78165 21.0858 8.74931 21.25 8.74931C21.4142 8.74931 21.5769 8.78165 21.7286 8.84451C21.8804 8.90736 22.0182 8.99949 22.1344 9.11562C22.2505 9.23176 22.3426 9.36964 22.4055 9.52138C22.4683 9.67312 22.5007 9.83576 22.5007 10C22.5007 10.1642 22.4683 10.3269 22.4055 10.4786C22.3426 10.6304 22.2505 10.7682 22.1344 10.8844H22.1375Z"
                      fill="#E53935"
                      fillOpacity="0.5"
                    />
                  </svg>
                </div>
              </div>

              <p className="text-neutral-900 text-sm font-light  md:text-[14px] leading-relaxed mt-2 lg:mt-3 mb-2 lg:mb-6">
                Work with verified lending partners committed to transparent
                loan processing.
              </p>
            </div>
          </div>

          {/* Mobile CTA Button (at the bottom, centered) */}
          <div className="flex lg:hidden w-full justify-center mt-8">
            <a
              href={import.meta.env.VITE_WEBSITE_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#DE3226] hover:bg-[#A82A1B] text-white px-10 py-3.5 rounded-[12px] font-bold text-base shadow-sm active:scale-95 transition-all w-fit"
            >
              Apply Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
